import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  doc,
  setDoc,
  deleteDoc,
  collection,
  getDocs,
  getDoc,
} from "firebase/firestore";
import { db } from "../firebase";
import TopNav from "../components/TopNav";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import "../App.css";
import favIcon from "../assets/img/fav.png";
import favIconActive from "../assets/img/fav_active.png";
import { onAuthStateChanged } from "firebase/auth";

function ItemView() {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [favorites, setFavorites] = useState({});

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        const favSnap = await getDocs(
          collection(db, `users/${currentUser.uid}/favourite`)
        );
        const favData = {};
        favSnap.docs.forEach((doc) => {
          favData[doc.id] = true;
        });
        setFavorites(favData);
      }
    });
    return () => unsub();
  }, []);

  const toggleFavorite = async (itemId) => {
    if (!user) return alert("Please log in to favorite jobs.");
    const favRef = doc(db, `users/${user.uid}/favourite/${itemId}`);

    if (favorites[itemId]) {
      await deleteDoc(favRef);
      setFavorites((prev) => {
        const updated = { ...prev };
        delete updated[itemId];
        return updated;
      });
    } else {
      await setDoc(favRef, { savedAt: new Date() });
      setFavorites((prev) => ({ ...prev, [itemId]: true }));
    }
  };

  useEffect(() => {
    const fetchJob = async () => {
      const docRef = doc(db, "items", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setJob({ id: docSnap.id, ...docSnap.data() });
      }
    };
    fetchJob();
  }, [id]);

  if (!job) return <div>Loading...</div>;

  return (
    <div className="auth-container">
      <TopNav />

      <div className="item-view">
        <img
          src={job.image || "/no_image.png"}
          alt="Job"
          className="item-image"
        />

        <button
          className="fav-btn view"
          onClick={() => toggleFavorite(job.id)}
          title={
            favorites[job.id] ? "Remove from Favorites" : "Add to Favorites"
          }
        >
          <img
            src={favorites[job.id] ? favIconActive : favIcon}
            alt="Favorite Icon"
            className="fav-icon"
          />
        </button>

        <h1 className="item-title">{job.name}</h1>

        <table className="job-info-table">
          <tbody>
            <tr>
              <th>Location</th>
              <td>{job.place}</td>
            </tr>
            <tr>
              <th>Type</th>
              <td>{job.type}</td>
            </tr>
            <tr>
              <th>Category</th>
              <td>{job.occ}</td>
            </tr>
            <tr>
              <th>Salary</th>
              <td>{job.salary}</td>
            </tr>
          </tbody>
        </table>

        <div
          className="item-desc"
          dangerouslySetInnerHTML={{ __html: job.desc }}
        ></div>
      </div>

      <div className="action-buttons">
        <button
          className="action-btn apply-btn"
          onClick={() => {
            const user = auth.currentUser;
            if (!user) {
              navigate("/auth"); // redirect to login
            } else {
              navigate(`/apply/${id}`); // pass job ID
            }
          }}
        >
          Apply
        </button>
        <a
          href={`mailto:admin@work-mart.jp?subject=Inquiry about Job [${job?.id}] - ${job?.name}&body=Hello,%0D%0A%0D%0AI would like to inquire about the following job:%0D%0AJob ID: ${job?.id}%0D%0AJob Title: ${job?.name}%0D%0AType: ${job?.type}%0D%0ACategory: ${job?.occ}%0D%0ALocation: ${job?.place}%0D%0ASalary: ${job?.salary}%0D%0A%0D%0AThank you.`}
          className="action-btn chat-btn"
        >
          Message
        </a>
      </div>
    </div>
  );
}

export default ItemView;
